import { COMPANY, ADDRESS_FULL } from './company'

const es = {
  nav: {
    home: 'Inicio',
    about: 'Nosotros',
    services: 'Servicios',
    howItWorks: 'Cómo Funciona',
    faq: 'Preguntas',
    contact: 'Contacto',
    primary: 'Navegación principal',
    mobile: 'Navegación móvil',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    requestFunding: 'Solicitar Financiación',
    topBar: 'Intermediación independiente de préstamos e inversión — más de 40 países',
    language: 'Idioma',
    breadcrumb: 'Ruta de navegación',
  },
  hero: {
    badge: 'Intermediación independiente — no somos prestamista',
    titleTop: 'Conectamos el Capital con la',
    titleAccent: 'Oportunidad en Todo el Mundo',
    subtitle:
      'Ayudamos a empresas, emprendedores, promotores e inversores a acceder a financiación y capital estratégico a través de nuestra red global de socios financieros.',
    ctaPrimary: 'Solicitar Financiación',
    ctaSecondary: 'Ser Socio Financiero',
    heroImageAlt: 'Distrito financiero internacional al anochecer',
  },
  overview: {
    eyebrow: 'La Compañía',
    title: 'Un puente independiente entre el capital y la oportunidad',
    paragraphs: [
      'Somos una firma internacional de intermediación de préstamos e inversión con sede en España. No somos un banco ni un prestamista directo. Nuestra única función es entender correctamente una necesidad de financiación y presentarla ante las instituciones e inversores con mayor probabilidad de respaldarla.',
      'Nuestra red incluye bancos comerciales, fondos de deuda privada, compañías de inversión, family offices, firmas de capital riesgo y private equity, inversores privados y socios institucionales en más de cuarenta países.',
      'Cada consulta se evalúa por sus méritos, se trata con absoluta confidencialidad y avanza únicamente con su autorización por escrito.',
    ],
    link: 'Más sobre la firma',
    statValue: '40+',
    statLabel: 'Países atendidos',
    imageAlt: 'Sala de juntas corporativa minimalista con vistas a la ciudad',
  },
  services: {
    eyebrow: 'Nuestros Servicios',
    title: 'Soluciones de capital presentadas con precisión',
    description:
      'Ocho disciplinas que cubren todo el espectro de necesidades de deuda, capital y asesoramiento para empresas con vocación internacional.',
    learnMore: 'Saber más',
  },
  industries: {
    eyebrow: 'Sectores que Atendemos',
    title: 'Conocimiento sectorial en toda la economía global',
    description:
      'Los prestamistas e inversores financian lo que comprenden. Alineamos su necesidad con socios que tienen apetito real por su sector.',
  },
  why: {
    eyebrow: 'Por Qué Elegirnos',
    title: 'Los estándares que nuestros clientes esperan de un intermediario',
    description:
      'Discreción, rigor y franqueza. Trabajamos como trabajan las contrapartes institucionales.',
  },
  process: {
    eyebrow: 'Proceso Sencillo',
    title: 'Siete pasos meditados desde la consulta hasta el cierre',
    description:
      'Un recorrido estructurado que le mantiene informado en cada etapa, sin contactar con ningún socio financiero sin su consentimiento.',
    fullDetail: 'Detalle Completo',
    seeHow: 'Ver cómo funciona',
  },
  testimonials: {
    eyebrow: 'Testimonios',
    title: 'La confianza de promotores, fundadores y consejos de administración',
    description: 'Los nombres se han abreviado conforme a nuestra política de confidencialidad.',
  },
  stats: { label: 'Estadísticas de la compañía' },
  cta: {
    eyebrow: 'Contáctenos Hoy',
    title: '¿Listo para hablar de sus necesidades de financiación?',
    description:
      'Comparta su necesidad con total confidencialidad. Si podemos ayudarle, un miembro senior de nuestro equipo le responderá en un día laborable.',
    ctaPrimary: 'Solicitar Financiación',
    ctaSecondary: 'Ser Socio Financiero',
  },
  footer: {
    about:
      'Firma independiente e internacional de intermediación de préstamos e inversión, con sede en Segovia (España), que conecta a prestatarios cualificados y solicitantes de capital con prestamistas, fondos e inversores de reputación en más de 40 países.',
    quickLinks: 'Enlaces Rápidos',
    legal: 'Legal',
    legalLinks: ['Política de Privacidad', 'Términos y Condiciones', 'Aviso Legal', 'Política de Cookies'],
    newsletterTitle: 'Perspectivas de Mercado',
    newsletterText:
      'Comentario trimestral sobre las condiciones del crédito global y los flujos de capital privado. Sin promociones.',
    emailLabel: 'Dirección de correo electrónico',
    emailPlaceholder: 'Su correo profesional',
    subscribe: 'Suscribirse a las perspectivas',
    subscribed: 'Gracias — revise su bandeja de entrada para confirmar.',
    disclaimerTitle: 'Aviso Legal',
    rights: 'Todos los derechos reservados.',
    registration: `Sociedad constituida en España. CIF ${COMPANY.cif} · Número de IVA ${COMPANY.vat}`,
    address: ADDRESS_FULL.es,
  },
}

const en: typeof es = {
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    howItWorks: 'How It Works',
    faq: 'FAQ',
    contact: 'Contact',
    primary: 'Primary navigation',
    mobile: 'Mobile navigation',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    requestFunding: 'Request Funding',
    topBar: 'Independent loan & investment introductions — 40+ countries',
    language: 'Language',
    breadcrumb: 'Breadcrumb',
  },
  hero: {
    badge: 'Independent Introductions — Not a Lender',
    titleTop: 'Connecting Capital with',
    titleAccent: 'Opportunity Worldwide',
    subtitle:
      'Helping businesses, entrepreneurs, developers and investors access financing and strategic capital through our global network of funding partners.',
    ctaPrimary: 'Request Funding',
    ctaSecondary: 'Become a Funding Partner',
    heroImageAlt: 'International financial district at dusk',
  },
  overview: {
    eyebrow: 'Company Overview',
    title: 'An independent bridge between capital and opportunity',
    paragraphs: [
      'We are an international loan and investment introduction firm based in Spain. We are not a bank and not a direct lender. Our sole function is to understand a funding requirement properly and place it in front of the institutions and investors most likely to support it.',
      'Our network spans commercial banks, private credit funds, investment companies, family offices, venture capital and private equity firms, private investors and institutional funding partners across more than forty countries.',
      'Every enquiry is assessed on its merits, handled confidentially, and progressed only with your written authorisation.',
    ],
    link: 'More about our firm',
    statValue: '40+',
    statLabel: 'Countries Served',
    imageAlt: 'Minimal corporate boardroom overlooking a city skyline',
  },
  services: {
    eyebrow: 'Our Services',
    title: 'Capital solutions introduced with precision',
    description:
      'Eight core disciplines covering the full spectrum of debt, equity and advisory requirements for internationally minded businesses.',
    learnMore: 'Learn more',
  },
  industries: {
    eyebrow: 'Industries We Serve',
    title: 'Sector fluency across the global economy',
    description:
      'Lenders and investors fund what they understand. We match your requirement to partners with a genuine appetite for your sector.',
  },
  why: {
    eyebrow: 'Why Choose Us',
    title: 'The standards our clients expect from an intermediary',
    description:
      'Discretion, diligence and directness. We work the way institutional counterparties work.',
  },
  process: {
    eyebrow: 'Simple Process',
    title: 'Seven considered steps from enquiry to completion',
    description:
      'A structured path that keeps you informed at every stage — with no approach made to any funding partner without your consent.',
    fullDetail: 'Full Detail',
    seeHow: 'See how it works',
  },
  testimonials: {
    eyebrow: 'Client Testimonials',
    title: 'Trusted by sponsors, founders and boards',
    description: 'Names have been abbreviated in line with our confidentiality policy.',
  },
  stats: { label: 'Company statistics' },
  cta: {
    eyebrow: 'Contact Us Today',
    title: 'Ready to discuss your funding requirements?',
    description:
      'Share your requirement in confidence. If we can assist, you will hear from a senior member of our team within one business day.',
    ctaPrimary: 'Request Funding',
    ctaSecondary: 'Become a Funding Partner',
  },
  footer: {
    about:
      'An independent international loan and investment introduction firm based in Segovia, Spain, connecting qualified borrowers and capital seekers with reputable lenders, funds and investors across 40+ countries.',
    quickLinks: 'Quick Links',
    legal: 'Legal',
    legalLinks: ['Privacy Policy', 'Terms & Conditions', 'Disclaimer', 'Cookie Policy'],
    newsletterTitle: 'Market & Funding Insights',
    newsletterText:
      'Quarterly commentary on global credit conditions and private capital flows. No promotions.',
    emailLabel: 'Email address',
    emailPlaceholder: 'Your business email',
    subscribe: 'Subscribe to insights',
    subscribed: 'Thank you — please check your inbox to confirm.',
    disclaimerTitle: 'Legal Disclaimer',
    rights: 'All rights reserved.',
    registration: `Registered in Spain. CIF ${COMPANY.cif} · VAT Number ${COMPANY.vat}`,
    address: ADDRESS_FULL.en,
  },
}

export const STRINGS = { es, en }
